/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, takeLatest, put, delay } from 'redux-saga/effects';
import * as Actions from './actions';
import { storeDetailVApolling } from './constants';
/**
 * WHATSNEXT-2565
 * Polling and optimized the code for VideoChat
 * Removed unwanteed and commented code
 * Implemneted the API call will happen after every one minute for 10 time's
 */
export function* showVideoChatAssistAct({ getMediaURL, sessionId, zipCode, isRepAvailable, pollCount = 0, errorTimer = 0, errorCount = 1 }) {
  const { pollingTimer, maxPollCount } = storeDetailVApolling;
  yield put({ type: 'SHOW_VIDEO_CHAT_ASSIST', response: isRepAvailable });
  if (pollCount <= maxPollCount) {
    if (pollCount > 1) yield delay((pollingTimer + errorTimer) * 1000);
    let isRepAvailableResponse;
    const apiResponse = yield call(Actions.checkVideoAssist(sessionId, zipCode));
    if (apiResponse) {
      if (Object.prototype.hasOwnProperty.call(apiResponse.data, 'mediaoutput')) {
        if (apiResponse.data && apiResponse.data.mediaoutput && apiResponse.data.mediaoutput.agentAvailabilityResponse === 'true') {
          isRepAvailableResponse = true;
        } else {
          isRepAvailableResponse = false;
        }
      } else {
        isRepAvailableResponse = 'error';
      }
    }
    if (isRepAvailableResponse !== 'error') {
      yield put({
        type: 'SHOW_VIDEO_CHAT_ASSIST_ACT',
        getMediaURL,
        sessionId,
        zipCode,
        isRepAvailable: isRepAvailableResponse,
        pollCount: pollCount + 1,
      });
    } else {
      const { maxErrorCount, errorTimer } = storeDetailVApolling;
      if (errorCount <= maxErrorCount) {
        yield put({
          type: 'SHOW_VIDEO_CHAT_ASSIST_ACT',
          getMediaURL,
          sessionId,
          zipCode,
          isRepAvailable: false,
          pollCount: pollCount + 1,
          errorTimer,
          errorCount: errorCount + 1,
        });
      }
    }
  }
}
// eslint-disable-next-line consistent-return
export const getAvailableRepFlag = (res = null) => {
  const response = res && res.data;
  if (response) {
    if (Object.prototype.hasOwnProperty.call(response, 'mediaoutput')) {
      if (response && response.mediaoutput && response.mediaoutput.agentAvailabilityResponse === 'true') {
        return true;
      }
      return false;
    }
    return 'error';
  }
};

function* actionWatcher() {
  yield takeLatest('SHOW_VIDEO_CHAT_ASSIST_ACT', showVideoChatAssistAct);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
